export const filtersSelector = (state) => state.filters;

export const generalSelector = (state) => state.general.data;
export const generalSettingsSelector = (state) => state.general.settings;

export const totalsSelector = (state) => state.totals.data;
export const totalsSettingsSelector = (state) => state.totals.settings;

export const appsSelector = (state) => state.apps.data;
export const appsTotalsSelector = (state) => state.apps.totals;
export const appsTotalCountSelector = (state) => state.apps.totalCount;
export const appsSettingsSelector = (state) => state.apps.settings;
export const appsFiltersSelector = (state) => state.apps.filters;

export const monetizationSelector = (state) => state.monetization.data;
export const monetizationSettingsSelector = (state) => state.monetization.settings;

export const timeSeriesSelector = (state) => state.timeSeries.data;
export const timeSeriesSettingsSelector = (state) => state.timeSeries.settings;

export const sdksSelector = (state) => state.sdks.data;
export const sdksSettingsSelector = (state) => state.sdks.settings;

export const companyInfoSelector = (state) => state.companyInfo.data;
export const companyInfoSettingsSelector = (state) => state.companyInfo.settings;
